import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import axios from "axios";

const basePath = "/api/v4/transactions/details";
const listingPath = (listingUuid) => `${basePath}/${listingUuid}`;
const options = {
  authenticity_token: window.ReactOnRails.authenticityToken(),
};

const apiClient = {
  listDetails: (listingUuid) => axios.get(listingPath(listingUuid), options),
  listAccountSources: (listingUuid) => axios.get(`${listingPath(listingUuid)}/sources`, options),
  listAccountPropertyTypes: (listingUuid) => axios.get(`${listingPath(listingUuid)}/property_types`, options),
  save: (listingUuid, payload) => axios.put(listingPath(listingUuid), { ...options, ...payload }),
  deleteListingImage: (imageDeletionUrl) =>
    axios({
      url: imageDeletionUrl,
      method: "delete",
      headers: {
        Accept: "text/javascript",
        "x-csrf-token": window.ReactOnRails.authenticityToken(),
      },
    }),
  updatePropertyDetail: (uuid, payload) =>
    axios.put(`${listingPath(uuid)}`, {
      ...options,
      listing: {
        details: [payload],
      },
    }),
  patchConnectedService: (uuid, payload) =>
    caseTransformingAxios.patch("/api/v4/transactions/connected_services", { ...options, uuid, ...payload }),
  createConnectedService: (uuid, { listingPersonId, roleId, personId, disabledReason } = {}) => {
    const getPayload = () => {
      if (disabledReason) return { disabled_reason: disabledReason };
      if (listingPersonId) return { listing_person_id: listingPersonId };
      if (roleId || personId) return { role_id: roleId, person_id: personId };
      return {};
    };

    return caseTransformingAxios.post("/api/v4/transactions/connected_services", {
      ...options,
      uuid,
      ...getPayload(),
    });
  },
  getConnectedService: (uuid) =>
    caseTransformingAxios.get("/api/v4/transactions/connected_services", { params: { uuid } }),
  updateConnectedService: (uuid, payload) =>
    caseTransformingAxios.put("/api/v4/transactions/connected_services", { ...options, uuid, ...payload }),
  sendConnectedServiceNow: (uuid) =>
    caseTransformingAxios.post("/api/v4/transactions/connected_services/send_now", { ...options, uuid }),
};

export default apiClient;
